<script>
  import Vue from 'vue'
  import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
  import { Card, Button, List, Checkbox, Avatar, Icon, Tooltip, Input, message } from 'ant-design-vue'
  import NewTicket from './client/components/NewTicket.vue'

  Vue.use(Card)
  Vue.use(Button)
  Vue.use(List)
  Vue.use(Checkbox)
  Vue.use(Avatar)
  Vue.use(Icon)
  Vue.use(Tooltip)
  Vue.use(Input)

  export default {
    components: {
      NewTicket
    },
    metaInfo: {
      title: 'Quantify'
    },
    data() {
      return {
        loading: false,
        newTicketView: false,
        searchStr: this.prTitle || undefined
      }
    },
    watch: {
      searchStr(str) {
        this.pickIssues({ query: str })
      }
    },
    computed: {
      ...mapState(['tickets', 'github']),
      ...mapGetters(['jiraHost', 'isSessionActive', 'jiraAuthLink', 'isJiraSessionActive', 'prTitle']),
      renderedTickets() {
        return this.tickets.map(e => ({
          ...e,
          externalLink: `${this.jiraHost}/browse/${e.key}`,
          icon: `${this.jiraHost}${e.img}`
        }))
      },
      pagination() {
        return {
          hideOnSinglePage: true,
          pageSize: 5,
          size: 'small'
        }
      },
      linkedItems() {
        return this.tickets.filter(e => e.linked)
          .map(e => ({
            key: e.key,
            type: ((e.fields || {}).issuetype || {}).name || ''
          }))
      },
      linkedItemsCount() {
        const count = this.linkedItems.length
        return count > 0 ? count : ''
      }
    },
    methods: {
      ...mapActions(['init', 'pickIssues', 'assignTickets', 'initAuthSession', 'fetchTicketFields']),
      ...mapMutations(['toggleTicketLink']),
      toggleCheckbox(key) {
        this.toggleTicketLink(key)
        this.fetchTicketFields(key)

        // const action = this.selectedItems[key] === true ? 'Linked' : 'Unlinked'
        // message.success({ key: 'toggle', content: `${action} ${key}` })
      },
      done() {
        this.loading = true

        return this.assignTickets({ linked: this.linkedItems })
          .then(() => {
            message.success('Taking you back...')
            this.$nextTick(() => {
              window.location.href = this.github.link
            })
          })
          .catch(() => { message.error('Error') })
          .finally(() => { this.loading = false })
      }
    },
    mounted() {
      this.init()

      if (!this.isJiraSessionActive) {
        message.loading('Authenticating', 4)
        setTimeout(() => this.initAuthSession(), 4000)
        return
      }

      this.pickIssues()
    }
  }
</script>

<template>
  <div class="container">
    <div class="logo row">
      <div class="column">
        <img
          alt="Quantify"
          src="https://s3.amazonaws.com/quantify-web-assets/identity/quantify_icon_jira.png"
          style="width: 40px; height: 40px; border-radius: 50%;"
        />
        <br>Quantify
      </div>
      <div class="column">
        <a :href="jiraAuthLink">Auth</a>
      </div>
    </div>

    <new-ticket v-if="newTicketView" @cancel="newTicketView = false" />

    <a-list
      item-layout="horizontal"
      :data-source="renderedTickets"
      :pagination="pagination"
      bordered
      class="row"
      v-show="!newTicketView"
    >
      <a-input-search
        slot="header"
        v-model="searchStr"
        placeholder="Search"
        enter-button
        v-show="!newTicketView"
      />

      <a-list-item slot="renderItem" slot-scope="item" @click="toggleCheckbox(item.key)">
        <a-list-item-meta>
          <span slot="title">
            <a-tooltip title="Link this ticket to PR" :mouse-enter-delay="0.5" placement="left">
              <a-icon
                type="api"
                style="font-size: 20px"
                :class="{ active: item.linked }"
              />
            </a-tooltip>
            <strong><img :src="item.icon" width="16" height="16" class="ticketIcon" /> {{ item.key }}</strong>
            <span>{{ item.summaryText }}</span>
          </span>
        </a-list-item-meta>

        <a slot="actions" :href="item.externalLink" target="_blank" @click.stop>
          <a-tooltip title="Open Jira ticket" :mouse-enter-delay="0.5" placement="right">
            <a-icon type="link" />
          </a-tooltip>
        </a>
      </a-list-item>
      <span slot="footer">
        <a-button @click="done" :loading="loading" type="primary" class="submit" :disabled="linkedItems.length === 0">
          Link {{ linkedItems.length }} item(s)
        </a-button>
        <a-button @click="newTicketView = true">New Ticket</a-button>
      </span>
    </a-list>

  </div>
</template>

<style scoped>
  .container, .row {
    max-width: 600px;
    margin: 0 auto;
  }
  .logo {
    text-align: center;
    padding: 10px;
  }
  .anticon-api {
    color: darkgray;
    float: left;
    margin-right: 20px;
  }
  .anticon-api.active {
    color: green;
  }
  .ant-list-item-meta-title {
    cursor: pointer;
  }
  .ticketIcon {
    margin-right: 5px;
  }
</style>
